import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { AI_CENTER_AREA_SLUGS } from './aiCenterAreas';
import { resolveLegacyAiCenter } from './legacyRedirect';
import { agentSlugForKind } from './aiSettingsCategories';

// Central da IA com rota própria para cada área, item, campanha e categoria
// dos Ajustes (D5): o voltar do navegador funciona e cada coisa é uma página.
const BASE = 'accounts/:accountId/v2/ai-center';
const AREA = `:area(${AI_CENTER_AREA_SLUGS.join('|')})`;

const meta = (permissions = ['administrator', 'agent']) => ({
  permissions,
  featureFlag: FEATURE_FLAGS.AI_ACTION_CENTER,
});

// `/agents?kind=social` vira `ajustes/modelos/comentarios`; o resto da query
// (return_to, from_world) segue junto.
export const agentsRedirect = to => {
  const { kind, ...query } = to.query || {};
  const section = agentSlugForKind(String(kind || ''));
  return {
    name: 'ai_settings',
    params: {
      accountId: to.params.accountId,
      category: 'modelos',
      ...(section ? { section } : {}),
    },
    query,
  };
};

// A ordem importa para quem lê: campanha antes do item genérico, item antes
// da área. O casamento em si é pelo formato do caminho.
export const routes = [
  {
    // Endereço antigo e entrada da Central. Com `tab` na query, vai direto
    // para a área (ou item) nova; sem `tab`, a página escolhe a primeira área
    // ligada assim que as features da conta chegam.
    path: frontendURL(BASE),
    name: 'ai_center',
    component: () => import('./pages/AiCenterAreaPage.vue'),
    beforeEnter: to => resolveLegacyAiCenter(to) || true,
    meta: meta(),
  },
  {
    // Endereço antigo da tela de agentes: o conteúdo mora em Ajustes da IA >
    // Modelos e agentes. `?kind=` abre o agente daquela área.
    path: frontendURL(`${BASE}/agents`),
    name: 'ai_center_agents',
    redirect: agentsRedirect,
    meta: meta(['administrator']),
  },
  {
    path: frontendURL(`${BASE}/ajustes/:category?/:section?`),
    name: 'ai_settings',
    component: () => import('./pages/AiSettingsPage.vue'),
    meta: meta(),
  },
  {
    // Modo rápido das Oportunidades (D43): um item por vez, em tela cheia.
    path: frontendURL(`${BASE}/oportunidades/rapido`),
    name: 'ai_center_quick',
    component: () => import('./pages/AiQuickModePage.vue'),
    meta: meta(),
  },
  {
    path: frontendURL(`${BASE}/comentarios/campanha/:itemId(\\d+)`),
    name: 'ai_center_campaign',
    component: () => import('./pages/AiCampaignPage.vue'),
    meta: meta(),
  },
  {
    path: frontendURL(`${BASE}/${AREA}/:itemId(\\d+)`),
    name: 'ai_center_item',
    component: () => import('./pages/AiCenterItemPage.vue'),
    meta: meta(),
  },
  {
    path: frontendURL(`${BASE}/${AREA}`),
    name: 'ai_center_area',
    component: () => import('./pages/AiCenterAreaPage.vue'),
    meta: meta(),
  },
];
